import { useState, useMemo, useEffect } from 'react';

function usePagination({
  data,
  pagination,
  pageSize,
  pageCount,
  currentPageNumber,
  onPageChange,
}: {
  data: Record<string, any>;
  pagination: 'front-end' | 'back-end' | null;
  pageSize: number;
  pageCount: number | null;
  currentPageNumber: number | null; // back-end use  Or  Front-end use
  onPageChange: ((page: number) => void | Promise<void>) | null;
}) {
  const [autoCurrentPage, setAutoCurrentPage] = useState(1);

  const currentPage = useMemo(() => {
    if (currentPageNumber) {
      return currentPageNumber;
    }
    return autoCurrentPage;
  }, [currentPageNumber, autoCurrentPage]);

  const setCurrentPage = useMemo(() => {
    if (onPageChange) {
      return onPageChange;
    }
    return setAutoCurrentPage;
  }, [onPageChange, setAutoCurrentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize, setCurrentPage]);

  const currentPageData = useMemo(() => {
    if (pagination === 'front-end') {
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      return data.slice(start, end);
    }
    return data;
  }, [currentPage, data, pageSize, pagination]);

  const totalPage = useMemo(() => {
    if (pagination === 'front-end') {
      return Math.ceil(data.length / pageSize);
    }
    return pageCount || Math.ceil(data.length / pageSize);
  }, [pageCount, data, pageSize, pagination]);

  return {
    currentPage,
    setCurrentPage,
    currentPageData,
    totalPage,
  };
}

export default usePagination;
